var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeWayIntersectionTwoLanes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "road-lines",
    d: "     M -100 0     L 120 0",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeDasharray: "12 9",
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 60,
    x: -100,
    y: -30,
    fill: "#3a4149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a4149",
    d: "     M 40 -30     L 40 -19     L -40 -19     L -40 -30     Q -30 -30 -30 -40     L -30 -130     L 30 -130     L 30 -40     Q 30 -30 40 -30"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "rotate(90) translate(-150,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeWayIntersectionTwoLanes);
export default __webpack_public_path__ + "static/media/three-way-intersection-two-lanes.5e45c1321e3745cecf827745f34506df.svg";
export { ForwardRef as ReactComponent };